/*
Modifed by Egor
убрал триггер при старте
*/
/**
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

/**
 * (C) 2008 Syronex / J.M. Rosengard
 * http://www.syronex.com/software/jquery-color-picker
 *
 * - Check mark is either black or white, depending on the darkness
 *   of the color selected.
 * - Fixed a bug in the original plugin that led to problems when there is
 *   more than one colorPicker in a document.
 *
 * This is based on:
 *
 * jQuery colorSelect plugin 0.9
 * http://plugins.jquery.com/project/colorPickerAgain
 * Copyright (c) 2008 Otaku RzO (Renzo Galo Castro Jurado).
 * (Original author URL & domain name no longer available.)
 *
 */
import jQuery from "jquery";

let $ = jQuery;

(function($) {
    $.fn.colorPicker = function($$options) {
        // Defaults
        let defaults;

        defaults = {
            color: ["#ffffff", "#000000", "#e8e7e7", "#42536a", "#5b9cd6", "#ee7e2d", "#a6a7a7", "#ffc100", "#4273c5", "#71af45",

                "#f2f2f2", "#808080", "#d1cfcf", "#d7dde5", "#dfecf6", "#fbe6d6", "#eeeeee", "#fff2cd", "#dae3f3", "#e3f0da",
                "#d9d9d9", "#585858", "#afadad", "#aebacb", "#bed8ef", "#f7ccae", "#dcdcdc", "#fee69a", "#b5c7e8", "#c6e1b5",
                "#c0c0c0", "#3d3d3d", "#767171", "#8597b2", "#9dc4e6", "#f4b384", "#cacaca", "#ffda65", "#8facdc", "#a9d18e",
                "#a6a7a7", "#212121", "#373535", "#2e3d4e", "#2a76b6", "#c65a09", "#7c7c7c", "#c09100", "#2b5397", "#528232",
                "#808080", "#040404", "#100e0e", "#1c2532", "#184d7a", "#843903", "#515151", "#806000", "#193564", "#34551e",

                "#B02B2C", "#FF7400", "#FF0096", "#FFFF88", "#CDEB8B", "#6BBA70", "#4096EE", "#0071c1", "#001a60", "#712ca1"],

            defaultColor: 0,
            columns: 0,
            defaultTrigger: false, // egor modified
            click(/* $color */) {
            }
        };

        let $settings = $.extend({}, defaults, $$options);

        // Iterate and reformat each matched element
        return this.each(function() {
            let $this = $(this);
            // build element specific options
            let o = $.meta ? $.extend({}, $settings, $this.data()) : $settings;
            let $$oldIndex = typeof(o.defaultColor) == "number" ? o.defaultColor : -1;

            let _html = "";
            for (let i = 0; i < o.color.length; i++) {
                if ( i < 10 ) {
                    _html += `<div style="background-color:${o.color[i]};margin-bottom:10px;margin-right:3px"></div>`;
                } else if ( i > 59 ) {
                    _html += `<div style="background-color:${o.color[i]};margin-top:10px;margin-right:3px;"></div>`;
                } else {
                    _html += "<div style=\"background-color:" + o.color[i] + ";margin-right:3px" + "\"></div>";
                }
                if ( $$oldIndex === -1 && o.defaultColor === o.color[i] ) $$oldIndex = i;
            }

            $this.html("<div class=\"jColorSelect\">" + _html + "</div>");
            let $color = $this.children(".jColorSelect").children("div");
            // Set container width
            let w = ($color.width() + 2 + 2) * (o.columns > 0 ? o.columns : o.color.length );
            $this.children(".jColorSelect").css("width",w);

            // Subscribe to click event of each color box
            $color.each(function(i) {
                $(this).click(function() {
                    //  if( $$oldIndex == i ) return;
                    if ( $$oldIndex > -1 ) {
                        let cell = $color.eq($$oldIndex);
                        if ( cell.hasClass("check") ) {cell.removeClass(
                            "check").removeClass("checkwht").removeClass("checkblk");}
                    }
                    // Keep index
                    $$oldIndex = i;
                    $(this).addClass("check").addClass(isdark(o.color[i]) ? "checkwht" : "checkblk");
                    // Trigger user event
                    o.click(o.color[i]);
                });
            });

            // Simulate click for defaultColor
            let _tmp = $$oldIndex;
            $$oldIndex = -1;
            if ( $settings.defaultTrigger ) {
                $color.eq(_tmp).trigger("click");
            }
        });
    };


})(jQuery);

/**
* Return true if color is dark, false otherwise.
* (C) 2008 Syronex / J.M. Rosengard
**/
function isdark(color) {
    let colr = parseInt(color.substr(1), 16);
    return (colr >>> 16) // R
+ ((colr >>> 8) & 0x00ff) // G
+ (colr & 0x0000ff) // B
< 500;
}

$.isDarkColor = isdark;
